import {
  Component,
  OnInit,
  NgZone,
  PLATFORM_ID,
  Inject,
  OnDestroy
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';
import { TaskService } from './../../services/task.service';

@Component({
  selector: 'ab-print',
  template: '',
  styleUrls: ['./print.component.scss']
})
export class PrintComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  constructor(
    private taskService: TaskService,
    private ngZone: NgZone,
    @Inject(PLATFORM_ID) private platform
  ) {}

  ngOnInit() {
    this.subscription = this.taskService
      .onTasksComplete()
      .subscribe(response => {
        if (response) {
          setTimeout(() => {
            this.triggerBrowserPrint();
          }, 1000);
        }
      });
  }

  triggerBrowserPrint() {
    if (isPlatformBrowser(this.platform)) {
      this.ngZone.runOutsideAngular(() => {
        window.print();
        window.close();
      });
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
